import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';

import type { ClickstreamPayload, ZrmUserInfo } from '@zg-rentals/clickstream';

const analytics = defineAnalytics({ CLICKSTREAM });

export const trackEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmUserInfo>>('CLICKSTREAM');
